import PhoneInputFormItem from './PhoneInputFormItem';

export default PhoneInputFormItem;